import React from "react";
import { useTheme } from "libs/shared/hooks/use-theme.js"

const DomainContextNode = ({ data, selected, className, ...props }) => (
  <div className={`p-4 rounded-lg border ${className}`}>
    <h3 className="text-lg font-semibold mb-2">{data.label}</h3>
    {data.description && (
      <p className="text-sm text-gray-500">{data.description}</p>
    )}
    {data.context && (
      <div className="mt-2 text-sm text-gray-600">
        <pre className="whitespace-pre-wrap">{data.context}</pre>
      </div>
    )}
  </div>
);

export function ContextNode({ data, selected, ...props }) {
  const { theme } = useTheme();

  return (
    <div className={`${selected ? "ring-2 ring-purple-500" : ""}`}>
      <DomainContextNode
        data={data}
        selected={selected}
        className={`bg-${theme === "dark" ? "neutral-800" : "white"} border-${theme === "dark" ? "neutral-700" : "gray-200"
          }`}
        {...props}
      />
    </div>
  );
}
